//
// JS for save with friends inputs
//

const ElevPrices = require("./ElevPrices");
const {$find, onClickOrEnter, onEnter} = require("./ElevHelpers");
const {
	modifyCart,
	addItemsToCart,
	showAddToCartModal,
	getTotalQuantity,
} = require("./CartUtil");
const {openModalByName} = require("./ModalUtil");
const _ = require("lodash");

// - inputEl: the element where the quantity is input
// - skus: an array of sku items added by that quantity box
// - priceLineEl: the element where price previews are shown
function computeCodesInput() {
	const codeEl = _.first(
		$find(document, ".ba11-p-swf-set-row, .ba11-p-swf-indiv-row")
	);

	if (!codeEl) {
		return;
	}
	const sku = codeEl.getAttribute("data-set-sku");
	const priceLineEl = codeEl.querySelector(".ba11-p-swf-item-price-line");
	const inputEl = codeEl.querySelector(".ba11-p-swf-item-qty");

	return {inputEl, sku, priceLineEl};
}

function setupCodesInput(codesInputList) {
	function updateShownPrice(priceLineEl, total, totalNoDiscount) {
		let html = "$" + total.toFixed(2);
		if (totalNoDiscount > total) {
			html =
				`<div class="ba11-p-swf-item-price-line-original">` +
				`$` +
				totalNoDiscount.toFixed(2) +
				`</div>` +
				html;
		}
		priceLineEl.innerHTML = html;
	}

	const {inputEl, sku, priceLineEl} = codesInputList;

	const onChangeBehavior = _evt => {
		// We use parseFloat since fixQuantity will round and we can't detect and
		// fix fractional values if we round here.
		const quantityRaw = parseFloat(inputEl.value);
		const quantity = ElevPrices.fixQuantity(quantityRaw);
		inputEl.value = parseInt(quantity);

		const cart = [{sku, quantity}];
		const total = ElevPrices.calculateTotalItemPrice(cart);
		const totalNoDiscount = ElevPrices.calculateTotalItemPrice(cart, {
			skipDiscounts: true,
		});
		updateShownPrice(priceLineEl, total, totalNoDiscount);
	};

	inputEl.addEventListener("change", onChangeBehavior);

	// clicking enter should update the displayed info but not add it to cart yet
	onEnter(inputEl, onChangeBehavior);
}

function resetCodeInput() {
	const {inputEl, priceLineEl} = computeCodesInput();
	inputEl.value = 1;
	priceLineEl.innerHTML = "$99.99";
}

function computeCodesAddedItems(codesInputList) {
	const {inputEl, sku} = codesInputList;
	const quantity = parseInt(inputEl.value);

	return [{sku, quantity, options: {}}];
}

function setupSaveWithFriends() {
	const codesInputList = computeCodesInput();
	if (!codesInputList) {
		return;
	}
	setupCodesInput(codesInputList);

	const button = _.first($find(document, ".ba11-p-swf-add-button"));
	codesInputList.inputEl.addEventListener("change", () => {
		if (
			isNaN(codesInputList.inputEl.value) ||
			codesInputList.inputEl.value < 1
		) {
			button.classList.add("disabled");
			button.disabled = true;
		} else {
			button.classList.remove("disabled");
			button.disabled = false;
		}
	});

	onClickOrEnter(button, evt => {
		onEnterBehavior(button, codesInputList);
	});
}

function onEnterBehavior(button, codesInputList) {
	const itemsToAdd = computeCodesAddedItems(codesInputList);
	if (!itemsToAdd.length || itemsToAdd[0]?.quantity === 0) {
		// the passed in button will be refocused after the modal is closed
		openModalByName("noItemsSelected", button);
		return;
	}
	modifyCart(c => {
		addItemsToCart(itemsToAdd, c);
	});
	resetCodeInput();
	showAddToCartModal(getTotalQuantity(itemsToAdd), "code", button);
}

module.exports = {
	setupSaveWithFriends,
};
